import {
	SET_EVENT_LOCATIONS,
	CREATE_LOCATION,
	UPDATE_LOCATION,
	DELETE_LOCATION,
} from '../actions/actionTypes';

const preState = [];

export const locationsReducer = (state = preState, action) => {
	const stateDup = [...state];
	const { type, locations, location, locationID } = action;
	switch (type) {
		case SET_EVENT_LOCATIONS:
			return [...locations];
		case CREATE_LOCATION:
			return [...stateDup, location];
		case UPDATE_LOCATION:
			const { id } = location;
			const updatedList = stateDup.map(lctn => (id === lctn.id ? { ...lctn, ...location } : lctn));
			return updatedList;
		case DELETE_LOCATION:
			const removedList = stateDup.filter(lctn => locationID !== lctn.id);
			return removedList;
		default:
			return state;
	}
};

export default locationsReducer;
